// Adiciona um ouvinte de eventos para quando a página terminar de carregar
const btnAddToCart = document.querySelector(
    ".bls__product-action-inner .product-form__submit"
);

function showMessageToBuy() {
    const addToCartHome = document.querySelectorAll(
        ".product-form__buttons .product-form__submit"
    );
    if (addToCartHome) {
        for (const btnAdd of addToCartHome) {
            btnAdd.addEventListener("click", function (e) {
                setTimeout(() => {
                    const containerAppend = btnAdd.closest(".form");

                    if (containerAppend) {
                        containerAppend.append(messageLip);
                    }
                }, 500);

                setTimeout(() => {
                    messageLip.remove();
                    window.location.href = `/cart`;
                }, 1250);
            });
        }
    }
}

function showMessageToBuySimple() {
    const addToCartHome = document.querySelectorAll(
        ".product-form__buttons .product-form__submit"
    );
    if (addToCartHome) {
        for (const btnAdd of addToCartHome) {
            btnAdd.addEventListener("click", function (e) {
                setTimeout(() => {
                    const containerAppend = btnAdd.closest(".form");

                    if (containerAppend) {
                        containerAppend.append(messageLip);
                    }
                }, 500);

                setTimeout(() => {
                    messageLip.remove();
                    window.location.href = `/cart`;
                }, 1250);
            });
        }
    }
}

const addToInProduct = document.querySelectorAll(
    ".product-form__buttons .product-form__submit"
);

if (addToInProduct) {
    setTimeout(() => {
        showMessageToBuySimple();
    }, 500);
}

const btnActionInner = document.querySelectorAll(
    ".bls__product-action-inner .bls__product-quickview"
);

for (const actionInner of btnActionInner) {
    actionInner.addEventListener("click", function (e) {
        setTimeout(() => {
            showMessageToBuy();
        }, 500);
    });
}

const messageLip = document.createElement("div");
messageLip.classList.add("add_to_cart_message");

messageLip.innerHTML = `
            <span>Produto adicionado com sucesso!</span>
        `;

if (btnAddToCart) {
    btnAddToCart.addEventListener("click", function (e) {
        setTimeout(() => {
            const containerAppend = btnAddToCart.closest(".form");

            if (containerAppend) {
                containerAppend.append(messageLip);
            }
        }, 500);

        setTimeout(() => {
            messageLip.remove();
            window.location.href = `/cart`;
        }, 1250);
    });
}

document.addEventListener("DOMContentLoaded", () => {
    // Adiciona um ouvinte de eventos para a solicitação fetch
    window.addEventListener("fetch", async (event) => {
        // Verifica se a solicitação é para a URL desejada
        if (event.request.url === "https://tcure.com.br/cart/add") {
            try {
                // Realiza a solicitação fetch
                const response = await fetch(event.request);

                // Executa ação desejada após a conclusão do request
                console.log("Request concluído:", response);

                // Você pode fazer mais aqui, como disparar um evento personalizado
                // document.dispatchEvent(new CustomEvent('requestCompleted', { detail: response }));
            } catch (error) {
                console.error("Erro ao processar a solicitação:", error);
            }
        }
    });
});

function handleEventQuickView(b) {
    const input = b.querySelector("#productData");

    if (!input) return;

    const { value } = input;
    const productDataString = unescape(value);
    const productObject = JSON.parse(productDataString);

    if (!productObject) return;

    // Atribua o novo valor a window.productAction
    window.productAction = productObject;

    const event = new Event("productActionChange");
    window.dispatchEvent(event);
}
